import { render } from "./BikefittingLayout.vue?vue&type=template&id=3b0bb198"
const script = {}

import "./BikefittingLayout.vue?vue&type=style&index=0&id=3b0bb198&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__